// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cleffa: PokeData = {
  "id": 173,
  "name": "cleffa",
  "height": 3,
  "weight": 30,
  "base_experience": 44,
  "types": [
    PokeType.FAIRY
  ],
  "api_moves": [
    "pound",
    "tackle",
    "double-edge",
    "sing",
    "psychic",
    "splash",
    "sweet-kiss",
    "charm",
    "encore",
    "magical-leaf",
    "calm-mind",
    "copycat",
    "disarming-voice",
    "draining-kiss",
    "fairy-wind",
    "moonblast",
    "baby-doll-eyes"
  ],
  "moves": [
    "tackle",
    "psychic",
    "splash",
    "sweet-kiss",
    "calm-mind",
    "moonblast",
    "spirit-break",
    "starfall",
    "misty-terrain",
    "dazzling-gleam",
    "heal-bell",
    "moonlight",
    "guardian-bond"
  ],
  "evolution_chain": {
    "id": 14,
    "item": null,
    "species": [
      {
        "name": "cleffa",
        "order": 36,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "clefairy",
        "order": 37,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 173,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "clefable",
        "order": 38,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 35,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "moon-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 45.75,
    "speed": 15,
    "ability_power": 45
  },
  "stat_changes": [],
  "catch_rate": 150,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
